import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import LedgerFilterForm from 'components/installation/siteFilterForm/ledgerFilterForm';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import DatePicker from '../datePicker/datePicker';
import DropDownInput from '../Input/dropDownInput/dropDownInput';

const InstallationDateApproval = ({
    applyFilter,
    siteTypes = [],
    agenda= [],
  }) => {
    const filterInputs = {
        site_no: '',
        client_name: '',
        site_created_by: '',
        initial_date: '',
        old_date: '',
        changed_date: '',
        created_by: '',
        created_at: '',
        approved_by: '',
        approved_on: '',
        status: '',
    };
    const statusData=[
      {name: 'Pending', id: 1},
      {name: 'Approved', id: 2},
      {name: 'Rejected', id: 3},
    ];
    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    const [defaultStatus, setDefaultStatus] = useState(1);

    // console.log(filterInputs);

    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          applyFilter(filterFieldsData);
        }}
      >
          <>
            <ConstantInput
              label='Site No.'
              value={filterFieldsData.site_no}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, site_no: val })
              }
            />
            <ConstantInput
              label='Client Name'
              value={filterFieldsData.client_name}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, client_name: val })
              }
            />
            <ConstantInput
              label='Site Created By'
              value={filterFieldsData.site_created_by}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, site_created_by: val })
              }
            />
            <ConstantInput
              label='Request Raised By'
              value={filterFieldsData.created_by}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, created_by: val })
              }
            />
            <ConstantInput
              label='Approved By'
              value={filterFieldsData.approved_by}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, approved_by: val })
              }
            />
            <DropDownInput
                label={'Status'}
                data={statusData}
                value={filterFieldsData?.status ? 
                  statusData.find(item => item.id === filterFieldsData.status).name : 
                  'Pending'
                }                
                getIdValue={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, status: val.id })
                }
                />

              <DatePicker
                    handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, initial_date: val })
                    }
                    label={`Initial Installation Start Date`}
                    required={false}
                />
                <DatePicker
                    handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, old_date: val })
                    }
                    label={`Former Installation Start Date`}
                    required={false}
                />
                <DatePicker
                    handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, changed_date: val })
                    }
                    label={`Changed Installation Start Date`}
                    required={false}
                />
                <DatePicker
                    handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, created_at: val })
                    }
                    label={`Request Raised on`}
                    required={false}
                />
                <DatePicker
                    handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, approved_on: val })
                    }
                    label={`Approved on`}
                    required={false}
                />
          </>
            
        <br />
        <br />
        <br />
        <div className="btn-wrapper">
          <button disabled={false} type="submit" className="btn btn-primary">
            {localization.applyFilter}
            <img src="../images/arrow-right.png" alt="" />
          </button>
          <br />
          <br />
          <button
            onClick={() => {
              applyFilter(filterInputs);
            }}
            type="button"
            className="btn btn-primary"
          >
            {localization.removeFilter}
          </button>
        </div>
      </form>
    );
  };
    

InstallationDateApproval.propTypes = {
  showFilter: PropTypes.bool,
  filterToggle: PropTypes.func,
  applyFilter: PropTypes.func,
  
};

export default InstallationDateApproval;
